import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import MyAccountTemplate from "../../sections/my-account-template";
import MembershipDetailsSection from "../../sections/membership-details-section";
import MembershipModal from "./../MembershipModal";
import ChangeMarketModal from "../ChangeMarketModal";
import { genrateHeadingWithFirstName } from "../../utils/myAccount";
import "./style.scss";
import { connect } from "react-redux";
import { selectUserState } from "../../selectors/application";
import { useHistory } from "react-router-dom";
import cookie from "react-cookies";
import { S_LANG, webStorage } from "../../utils/webStorage";
import { checkIfAnyFirmOrder } from "../../utils/finalizeOrderUtils";

const MyAccountMembership = ({ user, rendering, fields, lang, match }) => {
  const {
    hero,
    accountMenu,
    membershipTitleType,
    membershipTitleBody,
    membershipBody,
    accordionItems,
    readMoreButton,
    ctaName,
    colorScheme,
    iconName,
    level3Disclaimer,
    membershipOverview,
    mebershipModalChangeToLevel1,
    mebershipModalChangeToLevel2,
    mebershipModalChangeToLevel3,
    mebershipModalChangeToLevel0,
    changeMarketModalHeading,
    changeMarketModalBody,
    countryLabel,
    countryMissingMessage,
    ctaChangeMatket,
    dontChangeMarketButtonText,
    needRedirectForChangeMembership,
    regions
  } = fields;
  const [showModalLevel0, setShowModalLevel0] = useState(false);
  const [showModalLevel1, setShowModalLevel1] = useState(false);
  const [showModalLevel2, setShowModalLevel2] = useState(false);
  const [showModalLevel3, setShowModalLevel3] = useState(false);
  const [showModalChangeMarket, setShowModalChangeMarket] = useState(false);
  const [selectedLevel, setSelectedLevel] = useState(null);
  // hide this component if firm order exists
  const [hideComponent, setHideComponent] = useState(true);

  const history = useHistory();
  let marketCookieName = "market-detector-selected-value";
  let options = [];

  if (regions?.fields?.regions) {
    regions.fields.regions.forEach((item, index) => {
      let { country, language, defaultLanguage } = item.fields;
      let cn = country?.fields?.phrase?.value;
      let defaultLang = defaultLanguage?.fields?.phrase?.value;
      language &&
        language.forEach((lang, key) => {
          let ln = lang?.fields?.phrase && lang?.fields?.phrase.value;
          let code = cn ? `${ln.toLowerCase()}-${cn}` : ln.toLowerCase();
          options.push({
            value: `${country?.fields?.key.value || "Global"} ${lang?.fields.key && lang?.fields.key.value}`,
            code,
            country: cn,
            defaultLanguage: defaultLang
          });
        });
    });
  }

  useEffect(() => {
    async function checkFinalizeOrder() {
      const firmOrders = await checkIfAnyFirmOrder();
      if (!firmOrders?.length > 0 && user.membershipCode !== "MEMBERSHIP01") {
        setHideComponent(false);
      }
    }

    checkFinalizeOrder();
  }, []);

  const changeMembership = (evt, level) => {
    setSelectedLevel(level);
    if (needRedirectForChangeMembership?.value && level.value !== "MEMBERSHIP01") {
      setShowModalChangeMarket(true);
    } else if (level.value === "MEMBERSHIP01") {
      setShowModalLevel0(true);
    } else if (level.value === "MEMBERSHIP02") {
      setShowModalLevel1(true);
    } else if (level.value === "MEMBERSHIP03") {
      setShowModalLevel2(true);
    } else if (level.value === "MEMBERSHIP04") {
      setShowModalLevel3(true);
    }
  };

  const changeMarketModal = {
    heading: {
      html: changeMarketModalHeading
    },
    body: changeMarketModalBody.value,
    button: {
      ...ctaChangeMatket.fields,
      link: {
        ...ctaChangeMatket.fields.link,
        value: { ...ctaChangeMatket.fields.link.value, href: null }
      }
    },
    country: {
      placeholder: countryLabel.value || "Country",
      options: options,
      enableFilter: true,
      warningMessage: countryMissingMessage.value
    },
    link: {
      text: dontChangeMarketButtonText.value,
      onClick: () => {
        setShowModalChangeMarket(false);
      }
    },
    disabled: false,
    onCloseClicked: function(e) {
      e.preventDefault();
      setShowModalChangeMarket(false);
    }
  };

  const setCookie = (_name, _value) => {
    const expires = new Date();
    expires.setDate(expires.getDate() + 365);
    cookie.save(_name, _value, {
      path: `/`,
      expires
    });
  };

  const changeMarket = data => {
    let cookieValue = data && data.country.code;
    if (cookieValue) {
      let currentLang = options.filter(item => item.code.toLowerCase() === cookieValue.toLowerCase());
      if (currentLang && currentLang.length <= 0) {
        window.location.href = "/en/";
        return;
      }
      setCookie(marketCookieName, cookieValue.toLowerCase());

      let pageRoute = ctaChangeMatket.fields.link.value.href;
      pageRoute = pageRoute.replace(`/${lang}/`, "");
      webStorage.set(S_LANG, data.country.code);
      window.location = `${window.location.origin}/${data.country.code.toLowerCase()}/${pageRoute}`;
    }
  };

  if (hideComponent) {
    return <></>;
  }

  return (
    <div className="my-account-membership-page" datasourceid={rendering.dataSource}>
      <MyAccountTemplate
        heroConfiguration={
          hero[0].fields
            ? {
                ...hero[0].fields,
                titleBody: genrateHeadingWithFirstName(hero[0].fields.titleBody, user ? user.firstName : "")
              }
            : {}
        }
        menu={accountMenu ? accountMenu[0].fields : {}}
      >
        <div className="my-account-membership-page-form">
          <MembershipDetailsSection
            {...{
              membershipTitleType,
              membershipTitleBody,
              membershipBody,
              membershipOverview: membershipOverview[0],
              membershipLink: readMoreButton,
              accordionItems,
              disclaimer: level3Disclaimer,
              button: {
                colorScheme,
                iconName,
                link: {
                  value: {
                    text: ctaName.value
                  }
                }
              },
              match: match,
              onChangeMembershipSubmit: (evt, level) => changeMembership(evt, level)
            }}
          />
        </div>
      </MyAccountTemplate>

      {showModalChangeMarket && (
        <ChangeMarketModal
          {...{
            ...changeMarketModal,
            open: showModalChangeMarket,
            onCloseClicked: () => setShowModalChangeMarket(false),
            onSubmitForm: data => changeMarket(data)
          }}
        />
      )}
      {showModalLevel0 && (
        <MembershipModal
          {...{
            ...mebershipModalChangeToLevel0.fields,
            lang,
            selectedLevel,
            onCloseClicked: () => setShowModalLevel0(false)
          }}
        />
      )}
      {showModalLevel1 && (
        <MembershipModal
          {...{
            ...mebershipModalChangeToLevel1.fields,
            lang,
            selectedLevel,
            onCloseClicked: () => setShowModalLevel1(false)
          }}
        />
      )}
      {showModalLevel2 && (
        <MembershipModal
          {...{
            ...mebershipModalChangeToLevel2.fields,
            lang,
            selectedLevel,
            onCloseClicked: () => setShowModalLevel2(false)
          }}
        />
      )}
      {showModalLevel3 && (
        <MembershipModal
          {...{
            ...mebershipModalChangeToLevel3.fields,
            link: {
              value: {
                href: mebershipModalChangeToLevel3.fields.link.value.href ? mebershipModalChangeToLevel3.fields.link.value.href + "#MEMBERSHIP04" : mebershipModalChangeToLevel3.fields.link.value.url + "#MEMBERSHIP04"
              }
            },
            lang,
            history,
            selectedLevel,
            onCloseClicked: () => setShowModalLevel3(false)
          }}
        />
      )}
    </div>
  );
};

MyAccountMembership.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    hero: PropTypes.array,
    accountMenu: PropTypes.array,
    membeshipTitleType: PropTypes.object,
    membershipTitleBody: PropTypes.object,
    membershipBody: PropTypes.shape({ value: PropTypes.string }),
    accordionItems: PropTypes.array,
    readMoreButton: PropTypes.object,
    ctaName: PropTypes.object,
    colorScheme: PropTypes.object,
    iconName: PropTypes.object,
    level3Disclaimer: PropTypes.shape({ value: PropTypes.string }),
    membershipOverview: PropTypes.array,
    mebershipModalChangeToLevel1: PropTypes.object,
    mebershipModalChangeToLevel2: PropTypes.object,
    mebershipModalChangeToLevel3: PropTypes.object,
    mebershipModalChangeToLevel0: PropTypes.object,
    changeMarketModalHeading: PropTypes.shape({ value: PropTypes.string }),
    changeMarketModalBody: PropTypes.shape({ value: PropTypes.string }),
    countryLabel: PropTypes.shape({ value: PropTypes.string }),
    countryMissingMessage: PropTypes.shape({ value: PropTypes.string }),
    ctaChangeMatket: PropTypes.object,
    dontChangeMarketButtonText: PropTypes.shape({ value: PropTypes.string }),
    needRedirectForChangeMembership: PropTypes.shape({ value: PropTypes.bool }),
    regions: PropTypes.object
  })
};

const mapStateToProps = state => ({
  user: selectUserState(state)
});

export default connect(mapStateToProps)(MyAccountMembership);
